<template>
  <EmployerZone />
</template>
<script>
import EmployerZone from '@/components/Organization/Profile/EmployerZone.vue'
export default {
  components: { EmployerZone }
}
</script>
